import { useTranslation } from 'react-i18next';
import {
  FilterType,
  resetMapState,
  setStopFilterAction,
  useAppDispatch,
} from '../../../redux';
import { SimpleButton } from '../Buttons';
import { useNavigateToMap } from '../hooks';

type OpenDefaultMapButtonProps = {
  readonly className?: string;
  readonly testId?: string;
};

export const OpenDefaultMapButton = ({
  className,
  testId,
}: OpenDefaultMapButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigateToMap = useNavigateToMap();

  const onOpenMap = () => {
    dispatch(resetMapState());
    /**
     * By default only stops that belong to displayed route are shown on map.
     * Now that no routes are shown on map, show all stops by default.
     */
    dispatch(
      setStopFilterAction({
        filterType: FilterType.ShowAllBusStops,
        isActive: true,
      }),
    );

    navigateToMap();
  };

  return (
    <SimpleButton className={className} onClick={onOpenMap} testId={testId}>
      {t(($) => $.map.open)}
    </SimpleButton>
  );
};
